import React from "react";
import * as Icons from "lucide-react";
import { PROCESS_STEPS } from "../mock";
import Reveal from "./Reveal";

const ProcessSection = () => (
  <section className="py-16 sm:py-20 bg-[#f7f9fc]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6">
      <Reveal className="text-center mb-12 max-w-2xl mx-auto">
        <span className="text-orange-brand font-bold text-sm uppercase tracking-wide">How It Works</span>
        <h2 className="text-3xl sm:text-4xl font-bold text-navy font-head mt-2">10-Step Formula for Exceptional Garment Care</h2>
        <p className="text-navy/60 mt-3">From doorstep pickup to a happy delivery — every step handled with motherly care.</p>
      </Reveal>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5">
        {PROCESS_STEPS.map((s, i) => {
          const Icon = Icons[s.icon] || Icons.Circle;
          return (
            <Reveal key={s.no} delay={i * 50}>
              <div className="group bg-white rounded-2xl p-5 border border-gray-100 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all text-center h-full relative">
                <span className="absolute top-3 right-4 text-2xl font-extrabold text-gray-100 font-head group-hover:text-orange-brand/20 transition-colors">{s.no}</span>
                <div className="w-14 h-14 mx-auto rounded-2xl bg-navy/5 group-hover:bg-orange-brand text-navy group-hover:text-white flex items-center justify-center transition-colors mb-3">
                  <Icon size={26} />
                </div>
                <h3 className="font-semibold text-sm text-navy font-head leading-snug">{s.title}</h3>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default ProcessSection;
